import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Grid,
  FormControl,
  TablePagination,
  useTheme,
  useMediaQuery,
  Collapse,
  IconButton,
  Button,
  Popover,
  Menu,
  MenuItem,
  Skeleton
} from "@mui/material";
import FilterListIcon from "@mui/icons-material/FilterList";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { CurrencyRupee as CurrencyRupeeIcon, Search as SearchIcon } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import SearchInput from "../customcomponents/CustomSearchInput";
import SelectInput from "../customcomponents/CustomSelectInput";
import PillComponent from "../customcomponents/CustomPillComponent";
import SingleDateRangeFilter from "../customcomponents/CustomFilterDateRangePicker";
import { fetchAllServicePayments } from "../api";


function PatientPaymentReportPage() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery("(max-width:800px)");

  // State and handlers
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [payments, setPayments] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [openRow, setOpenRow] = useState(null); // for collapsible row
  const [anchorEl, setAnchorEl] = useState(null);
  const [searchAnchorEl, setSearchAnchorEl] = useState(null);
  const openPopover = Boolean(searchAnchorEl);

  const navigate = useNavigate();
  
  const options = [
    { label: "Group", value: "all" },
    { label: "All", value: "group" },
    { label: "Paid", value: "paid" },
    { label: "Unpaid", value: "unpaid" },
  ];
  const handleSearchClick = (event) => {
  setSearchAnchorEl(event.currentTarget);
  };
  const handleSearchClose=()=>{
    // setSearchQuery('');
    setSearchAnchorEl(null);
  }
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (value) => {
    if (value) setStatusFilter(value);
    setAnchorEl(null);
  };

  
  const handleDateRangeChange = (from, to) => {
    setFromDate(from);
    setToDate(to);
    setPage(0);
  };
  // Aswin Start

 // Date helpers
const startOfDay = (d) => {
  const x = new Date(d);
  x.setHours(0, 0, 0, 0);
  return x;
};
const endOfDay = (d) => {
  const x = new Date(d);
  x.setHours(23, 59, 59, 999);
  return x;
};

const filteredPayments = payments
  .filter((payment) => {
    // Status filter
    if (statusFilter === "paid" && !payment.TASP_IsPaid) return false;
    if (statusFilter === "unpaid" && payment.TASP_IsPaid) return false;

    // Search filter
    if (searchQuery) {
      const q = searchQuery.toLowerCase();
      const hit =
        (payment.userName && payment.userName.toLowerCase().includes(q)) ||
        (payment.mobileNumber && payment.mobileNumber.includes(searchQuery)) ||
        (payment.email && payment.email.toLowerCase().includes(q));
      if (!hit) return false;
    }

    // Date range filter — handles single day and partial ranges
    if (fromDate || toDate) {
      const payTs = new Date(payment.TASP_Created_At).getTime();

      const rangeStart = fromDate
        ? startOfDay(fromDate).getTime()
        : startOfDay(toDate).getTime(); // only 'to' given → use that day

      const rangeEnd = toDate
        ? endOfDay(toDate).getTime()
        : endOfDay(fromDate).getTime(); // only 'from' given → same day

      if (payTs < rangeStart || payTs > rangeEnd) return false;
    }

    return true;
  })
  .sort((a, b) => new Date(b.TASP_Created_At) - new Date(a.TASP_Created_At));



  // const filteredPayments = ((payments) => {
  //   if (!Array.isArray(payments)) return [];
  //   let filtered = payments.slice();

  //   // Search filter (on person level)
  //   if (searchQuery) {
  //     const q = searchQuery.toLowerCase();
  //     filtered = filtered.filter(payment =>
  //       (payment.userName && payment.userName.toLowerCase().includes(q)) ||
  //       (payment.mobileNumber && payment.mobileNumber.includes(q)) ||
  //       (payment.email && payment.email.toLowerCase().includes(q))
  //     );
  //   }

    
  //   if (fromDate && toDate) {
  //     const from = new Date(fromDate);
  //     from.setHours(0,0,0,0);
  //     const to = new Date(toDate);
  //     to.setHours(23,59,59,999);

  //   }

  //   return true
  // }).sort((a, b) => {return new Date(b?.TASP_Created_At) - new Date(a?.TASP_Created_At)});



  const isGroup = isSmallScreen?statusFilter === "all" : statusFilter === "group" || statusFilter === "paid" || statusFilter === "unpaid";   

  // pagination sources
  const paginatedAll = filteredPayments.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  
  const groupKey = (p) =>
    `${p.userName || ""}|${p.mobileNumber || ""}|${p.email || ""}`;
  const patientMap = {};
  filteredPayments.forEach((p) => {
    console.log(p);
    const key = groupKey(p);
    if (!patientMap[key]) patientMap[key] = [];
    patientMap[key].push(p);
  });
  

  const patientList = Object.values(patientMap);
  // Pagination on patient level
  const paginatedPatients = patientList.slice(
    page * rowsPerPage,
    page * rowsPerPage + rowsPerPage
  );
  console.log(patientList);


  const dataForPagination = isGroup ? patientList : filteredPayments;
  

  console.log(dataForPagination);
  

  // Aswin End

  useEffect(() => {
    const fetchPayments = async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchAllServicePayments();
        setPayments(res.data || []);        
      } catch (err) {
        setError("Failed to fetch payment details.");
      } finally {
        setLoading(false);
      }
    };
    fetchPayments();
  }, []);

  // ...existing code...

  // Group payments by patient (by userName + mobileNumber + email as key)
  
  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleStatusFilterChange = (event) => {
    setStatusFilter(event.target.value);
    setPage(0);
  };

  // Calculate total amount for displayed payments
  const calculateTotalAmount = () => {
    return filteredPayments.reduce(
      (sum, p) => sum + (Number(p.TASP_Amount) || 0),
      0
    );
  };
  const calculateTotalCollectedAmount = () => {
    return filteredPayments.filter((p) => p.TASP_IsPaid).reduce(
      (sum, p) => sum + (Number(p.TASP_Amount) || 0),
      0
    );
  };
  const calculateTotalNonCollectedAmount = () => {
    return filteredPayments.filter((p) => !p.TASP_IsPaid).reduce(
      (sum, p) => sum + (Number(p.TASP_Amount) || 0),
      0
    );
  };
  
  
  // alphabetic order sl no
  const toAlphabetLabel = (num) => {
    let label = "";
  while (num >= 0) {
    label = String.fromCharCode((num % 26) + 97) + label; // 97 = 'a'
    num = Math.floor(num / 26) - 1;
  }
  return label;
};



  return (
    <Box sx={{ background: theme.palette.background.default }}>
      <Paper
        elevation={0} sx={{
        p: { xs: 2, sm: 3 },
        mb: 2,
        borderRadius: 3,
        background: theme.palette.mode == 'dark' ? '#32373a' :  'white',
        boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
        display: 'flex',
        flexDirection: { xs: 'row', md: 'row' },
        alignItems: 'center',
        gap: 2,
        justifyContent: 'space-between',
        position: 'sticky',
        top: isSmallScreen?10:0,
        zIndex: 1000,
      }}
      >
        <Typography
          variant={isSmallScreen ? "h6" : "h4"}
          sx={{
            fontWeight: 700,
            flex: 1,
            textTransform: "capitalize",
            color: "background.text",
          }}
        >
          Revenue Report
        </Typography>

        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1,flexDirection: { xs: 'row', sm: 'row' }, }}>
          {isSmallScreen ? (
            <IconButton
              onClick={() => navigate("/stats")}
              sx={{
                color: "#fff",
                width: 40,
                height: 40,
                fontSize: '1.3rem',
              }}
            >
              📊
            </IconButton>
          ):(
            <Button
              onClick={() => navigate("/stats")} 
              variant="contained"
              sx={{
                background: "linear-gradient(135deg, #6D5DFB 0%, #46C2FF 100%)",
                color: "#fff",
                fontWeight: 600,
                textTransform: "none",
                px: 3,
                py: 1,
                borderRadius: 3,
                boxShadow: "0 4px 12px rgba(109, 93, 251, 0.4)",
                "&:hover": {
                  background: "linear-gradient(135deg, #5A4AF4 0%, #3AB8FF 100%)",
                  boxShadow: "0 6px 16px rgba(109, 93, 251, 0.5)",
                },
              }}
            >
              📊 Stats
            </Button>
          )}
          {isSmallScreen?(
            <>
              <IconButton
                  onClick={handleSearchClick}
                  color='primary'
                  // sx={{
                  //   bgcolor: theme.palette.primary.main,
                  //   color: theme.palette.primary.contrastText,
                  //   borderRadius: 2, boxShadow: 1,
                  //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                  //   height: 40, width: 40,
                  // }}
                >
                  <SearchIcon />
                </IconButton>
                <Popover open={openPopover} anchorEl={searchAnchorEl} onClose={handleSearchClose}
                  anchorOrigin={{ vertical: 'bottom', horizontal: 'left', }}
                  transformOrigin={{  vertical: 'top',  horizontal: 'left', }}
                  PaperProps={{ sx: { p: 1, boxShadow: 'none', backgroundColor: 'rgba(255, 255, 255, 0.2)', borderRadius: 2, width: '60vw',  maxWidth: 400, }, }}
                >
                  <SearchInput value={searchQuery}onChange={(e) => { setSearchQuery(e.target.value); setPage(0); }}  autoFocus />  
                </Popover> 
              </>
          ):(
            <>
              <SearchInput value={searchQuery} onChange={(e) => { setSearchQuery(e.target.value); setPage(0);}} />
              <SingleDateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                showClearButton={true}
              />
            </>
          )}
          {isSmallScreen ? (
            <>
              <IconButton
                onClick={handleClick}
                color="primary"
                // sx={{
                //   bgcolor: theme.palette.primary.main,
                //   color: theme.palette.primary.contrastText,
                //   borderRadius: 2, boxShadow: 1,
                //   '&:hover': { bgcolor: theme.palette.primary.dark, boxShadow: 2, },
                //   height: 40, width: 40,
                // }}
              >
                <FilterListIcon />
              </IconButton>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={() => handleClose()}
              >
                {options.map((option) => (
                  <MenuItem
                  key={option.value}
                  selected={option.value === statusFilter}
                  onClick={() => handleClose(option.value)}
                  sx={{color:theme.palette.background.text}}
                  >
                    {option.label}
                  </MenuItem>
                ))}
              </Menu>
              <SingleDateRangeFilter
                onDateRangeChange={handleDateRangeChange}
                showClearButton={true}
              />
            </>
          ) : (
            // Full select for larger screens
            <FormControl
            size="small"
            sx={{
              minWidth: 240,
              background: theme.palette.background.paper,
              borderRadius: 1,
            }}
            >
              <SelectInput
                label="Filter"
                value={statusFilter}
                onChange={(e) => setStatusFilter(e.target.value)}
                options={options}
              />
            </FormControl>
          )}
        </Box>
      </Paper>
      {isSmallScreen ? (
        // <Box>
        //   {loading ? (
        //     <Box sx={{ p: 4, textAlign: "center" }}>
        //       <Typography sx={{ color: "background.text" }}>
        //         Loading payment details...
        //       </Typography>
        //     </Box>
        //   ) : error ? (
        //     <Box sx={{ p: 4, textAlign: "center", color: "red" }}>
        //       <Typography>{error}</Typography>
        //     </Box>
        //   ) : patientList.length === 0 ? (
        //     <Box sx={{ p: 4, textAlign: "center" }}>
        //       <Typography sx={{ color: "background.text" }}>
        //         No payment records found.
        //       </Typography>
        //     </Box>
        //   ) : (
        //     paginatedPatients.map((patientPayments, idx) => {
        //       const firstPayment = patientPayments[0];
        //       const totalPaidAmount = patientPayments.reduce(
        //       (sum, p) => sum + (p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0),0);

        //       const totalUnpaidAmount = patientPayments.reduce(
        //       (sum, p) => sum + (!p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0),0);
        //       return (
        //         <Paper
        //           key={groupKey(firstPayment)}
        //           elevation={2}
        //           sx={{
        //             mb: 2,
        //             borderRadius: 3,
        //             p: 2,
        //             background: theme.palette.background.paper,
        //             boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
        //           }}
        //         >
        //           <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: 'center' }}>
        //             <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#b0b0b0" }}>
        //               # {page * rowsPerPage + idx + 1}
        //             </Typography>
        //             <IconButton
        //               aria-label="expand card"
        //               size="small"
        //               onClick={() => setOpenRow(openRow === idx ? null : idx)}
        //             >
        //               {openRow === idx ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        //             </IconButton>
        //           </Box>
        //           <Box sx={{ mb: 1 }}>
        //             <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
        //               Total Collected: <CurrencyRupeeIcon sx={{ fontSize: 14, verticalAlign: 'middle' }} />{(totalPaidAmount).toLocaleString('en-IN')}/-
        //             </Typography>
        //             <Typography sx={{ fontWeight: 600, fontSize: 15 }}>
        //               Total Pending: <CurrencyRupeeIcon sx={{ fontSize: 14, verticalAlign: 'middle' }} />{(totalUnpaidAmount).toLocaleString('en-IN')}/-
        //             </Typography>
        //             <Typography sx={{ fontWeight: 600, fontSize: 15 }}>Name: <span style={{ fontWeight: 400 }}>{firstPayment.userName || '-'}</span></Typography>
        //             <Typography sx={{ fontWeight: 600, fontSize: 15 }}>Phone: <span style={{ fontWeight: 400 }}>{firstPayment.mobileNumber || '-'}</span></Typography>
        //             <Typography sx={{ fontWeight: 600, fontSize: 15 }}>Email: <span style={{ fontWeight: 400 }}>{firstPayment.email || '-'}</span></Typography>
        //           </Box>
        //           <Collapse in={openRow === idx} timeout="auto" unmountOnExit>
        //             <Box sx={{ mt: 1, p: 2, background: '#e6f2ff', borderRadius: 2 }}>
        //               {patientPayments.map((payment, pidx) => (
        //                 <Paper key={payment._id || pidx} elevation={0} sx={{ mb: 2, p: 2, background: '#f7fbff', borderRadius: 2 }}>
        //                   <Typography sx={{ fontWeight: 600, fontSize: 14, mb: 1 }}>Payment #{pidx + 1}</Typography>
        //                   {/* <Typography variant="body2"><b>Payment Method:</b> {payment.TASP_Payment_Method || '-'}</Typography> */}
        //                   <Typography variant="body2" color={payment?.TASP_Payment_Type === 1 ? "green" : 'red'}><b style={{color:'black'}}>Payment Type:</b> {payment.TASP_Payment_Type === 1 ? 'Online' : 'Offline'}</Typography>
        //                   <Typography variant="body2"><b>Date:</b> {payment.TASP_Created_At ? new Date(payment.TASP_Created_At).toLocaleString() : '-'}</Typography>
        //                   <Typography variant="body2"><b>Status:</b> <PillComponent status={payment.TASP_IsPaid ? 'paid' : 'unpaid'} /></Typography>
        //                   <Typography variant="body2"><b>Amount:</b> <CurrencyRupeeIcon fontSize="inherit" style={{ verticalAlign: 'middle' }} />{(Number(payment.TASP_Amount) || 0).toLocaleString('en-IN')}/-</Typography>
        //                   <Typography variant="body2"><b>PRO:</b> {payment.proName || '-'}</Typography>
        //                 </Paper>
        //               ))}
        //             </Box>
        //           </Collapse>
        //         </Paper>
        //       );
        //     })
        //   )}
        // </Box>
        <Box>
  {loading ? (
      <>
        {Array.from(new Array(5)).map((_, idx) => (
          <Paper
            key={idx}
            elevation={2}
            sx={{
              mb: 2,
              borderRadius: 3,
              p: 2,
              background: 'background.paper',
              boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
              m:1,mt:0
            }}
          >
            {/* Header with SL No. and expand button */}
            <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1, alignItems: 'center' }}>
              <Skeleton variant="text" width={40} height={24} />
              <Skeleton variant="circular" width={32} height={32} />
            </Box>

            {/* Totals and user info */}
            <Box sx={{ mb: 1, display: 'flex', flexDirection: 'column', gap: 0.5 }}>
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="60%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
              <Skeleton variant="text" width="50%" height={20} />
            </Box>
          </Paper>
        ))}
      </>
  ) : error ? (
    <Box sx={{ p: 4, textAlign: "center", color: "red" }}>
      <Typography>{error}</Typography>
    </Box>
  ) : dataForPagination.length === 0 ? (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography sx={{ color: "background.text" }}>No payment records found.</Typography>
    </Box>
  ) : isGroup ? (
    // ===== GROUPED CARD VIEW =====
    dataForPagination.map((patientPayments, idx) => {
      const firstPayment = patientPayments[0];
      const totalPaidAmount = patientPayments.reduce((sum, p) => sum + (p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0), 0);
      const totalUnpaidAmount = patientPayments.reduce((sum, p) => sum + (!p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0), 0);

      return (
        <Paper
          key={groupKey(firstPayment)}
          elevation={2}
          sx={{ m:1,mt:0, borderRadius: 3, p: 2, background: theme.palette.background.paper, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}
        >
          <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: 'center' }}>
            <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#b0b0b0",fontSize: '0.8rem' }}>
              # {page * rowsPerPage + idx + 1}
            </Typography>
            <IconButton aria-label="expand card" size="small" onClick={() => setOpenRow(openRow === idx ? null : idx)}>
              {openRow === idx ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </Box>

          <Box sx={{ mb: 1 }}>
            <Typography sx={{ fontWeight: 600, fontSize: 12,color:'background.text' }}>
              Total Collected: <CurrencyRupeeIcon sx={{ fontSize: 14, verticalAlign: 'middle' }} />
              {totalPaidAmount.toLocaleString('en-IN')}/-
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 12,color:'background.text' }}>
              Total Pending: <CurrencyRupeeIcon sx={{ fontSize: 14, verticalAlign: 'middle' }} />
              {totalUnpaidAmount.toLocaleString('en-IN')}/-
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 12,color:'background.text' }}>
              Name: <span style={{ fontWeight: 400 }}>{firstPayment.userName || '-'}</span>
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 12,color:'background.text' }}>
              Phone: <span style={{ fontWeight: 400 }}>{firstPayment.mobileNumber || '-'}</span>
            </Typography>
            <Typography sx={{ fontWeight: 600, fontSize: 12,color:'background.text' }}>
              Email: <span style={{ fontWeight: 400 }}>{firstPayment.userEmail || '-'}</span>
            </Typography>
          </Box>

          <Collapse in={openRow === idx} timeout="auto" unmountOnExit>
            <Box sx={{ mt: 1, p: 2, background: '#e6f2ff', borderRadius: 2 }}>
              {patientPayments.map((payment, pidx) => (
                <Paper key={payment._id || pidx} elevation={0} sx={{ mb: 2, p: 2, background: '#f7fbff', borderRadius: 2 }}>
                  <Typography sx={{ fontWeight: 600, fontSize: 12, mb: 1 }}>
                    {/* Alphabetic inner SL no. */}
                    {toAlphabetLabel(pidx)} • Payment
                  </Typography>
                  <Typography variant="body2" color={payment?.TASP_Payment_Type === 1 ? "green" : 'red'} sx={{fontSize:12}}>
                    <b style={{color:'black'}}>Payment Type:</b> {payment.TASP_Payment_Type === 1 ? 'Online' : 'Offline'}
                  </Typography>
                  <Typography variant="body2" sx={{fontSize:12}}><b>Date:</b> {payment.TASP_Created_At ? new Date(payment.TASP_Created_At).toLocaleString() : '-'}</Typography>
                  <Typography variant="body2" sx={{fontSize:12}}><b>Status:</b> <PillComponent status={payment.TASP_IsPaid ? 'paid' : 'unpaid'} /></Typography>
                  <Typography variant="body2" sx={{fontSize:12}}>
                    <b>Amount:</b> <CurrencyRupeeIcon fontSize="inherit" style={{ verticalAlign: 'middle' }} />
                    {(Number(payment.TASP_Amount) || 0).toLocaleString('en-IN')}/-
                  </Typography>
                  <Typography variant="body2" sx={{fontSize:12}}><b>PRO:</b> {payment.proName || '-'}</Typography>
                </Paper>
              ))}
            </Box>
          </Collapse>
        </Paper>
      );
    })
  ) : (
    // ===== ALL PAYMENTS CARD VIEW =====
    dataForPagination.map((p, idx) => (
      <Paper
        key={p._id || idx}
        elevation={2}
        sx={{ mb: 2, borderRadius: 3, p: 2, background: theme.palette.background.paper, boxShadow: "0 2px 12px rgba(0,0,0,0.06)" }}
      >
        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 1, alignItems: 'center' }}>
          <Typography variant="subtitle2" sx={{ fontWeight: 700, color: "#b0b0b0" }}>
            # {page * rowsPerPage + idx + 1}
          </Typography>
        </Box>

        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Name: <span style={{ fontWeight: 400 }}>{p.userName || '-'}</span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Phone: <span style={{ fontWeight: 400 }}>{p.mobileNumber || '-'}</span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Email: <span style={{ fontWeight: 400 }}>{p.userEmail || '-'}</span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Payment Type: <span style={{ fontWeight: 400, color: p?.TASP_Payment_Type === 1 ? 'green' : 'red' }}>
            {p.TASP_Payment_Type === 1 ? 'Online' : 'Offline'}
          </span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Status: <span style={{ fontWeight: 400 }}><PillComponent status={p.TASP_IsPaid ? 'paid' : 'unpaid'} /></span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Date: <span style={{ fontWeight: 400 }}>
            {p.TASP_Created_At ? new Date(p.TASP_Created_At).toLocaleString() : '-'}
          </span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          Amount: <span style={{ fontWeight: 400 }}>
            <CurrencyRupeeIcon fontSize="inherit" style={{ verticalAlign: 'middle' }} />
            {(Number(p.TASP_Amount)||0).toLocaleString('en-IN')}/-
          </span>
        </Typography>
        <Typography sx={{ fontWeight: 600, fontSize: 15,color:'background.text' }}>
          PRO: <span style={{ fontWeight: 400 }}>{p.proName || '-'}</span>
        </Typography>
      </Paper>
    ))
  )}

        </Box>


      ) : (
        <Paper
          elevation={1}
          sx={{
            borderRadius: 3,
            boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
            overflow: "auto",
            background: theme.palette.background.paper,
            mb: 3,
          }}
        >
          {loading ? (
            <TableContainer sx={{ maxHeight: 540 }}>
              <Table stickyHeader>
                <TableHead>
                  <TableRow>
                    {['SL No.', 'Name', 'Phone Number', 'Email', 'Total Collected', 'Total Pending', 'Action'].map((head, idx) => (
                      <TableCell
                        key={idx}
                        sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main,
                          color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText,
                        }}
                      >
                        {head}
                      </TableCell>
                    ))}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Array.from(new Array(10)).map((_, idx) => (
                    <React.Fragment key={idx}>
                      <TableRow>
                        {Array.from(new Array(7)).map((__, cellIdx) => (
                          <TableCell key={cellIdx} sx={{ color: theme.palette.text.primary }}>
                            <Skeleton variant="text" height={20} />
                          </TableCell>
                        ))}
                      </TableRow>
                    </React.Fragment>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          ) : error ? (
            <Box sx={{ p: 4, textAlign: "center", color: "red" }}>
              <Typography>{error}</Typography>
            </Box>
          ) : (
            
            <TableContainer sx={{ maxHeight: 540 }}>
            <Table stickyHeader>
              {!isGroup ? (
                // ========== GROUPED TABLE (existing) ==========
                <>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }}>SL No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Name</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Phone Number</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Email</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Total Collected</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Total Pending</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Action</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedPatients.map((patientPayments, idx) => {
                      const firstPayment = patientPayments[0];
                      const totalPaidAmount = patientPayments.reduce(
                        (sum, p) => sum + (p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0), 0
                      );
                      const totalUnpaidAmount = patientPayments.reduce(
                        (sum, p) => sum + (!p.TASP_IsPaid ? (Number(p.TASP_Amount) || 0) : 0), 0
                      );

                      return (
                        <React.Fragment key={groupKey(firstPayment)}>
                          <TableRow onClick={() => setOpenRow(openRow === idx ? null : idx)}>
                            <TableCell sx={{color:'background.text'}}>{page * rowsPerPage + idx + 1}</TableCell>
                            <TableCell sx={{color:'background.text'}}>{firstPayment.userName || "-"}</TableCell>
                            <TableCell sx={{color:'background.text'}}>{firstPayment.mobileNumber || "-"}</TableCell>
                            <TableCell sx={{color:'background.text'}}>{firstPayment.userEmail || "-"}</TableCell>
                            <TableCell sx={{color:'background.text'}}>
                              <CurrencyRupeeIcon fontSize="inherit" style={{verticalAlign:'middle'}} />
                              {totalPaidAmount.toLocaleString('en-IN')}
                            </TableCell>
                            <TableCell sx={{color:'background.text'}}>
                              <CurrencyRupeeIcon fontSize="inherit" style={{verticalAlign:'middle'}} />
                              {totalUnpaidAmount.toLocaleString('en-IN')}
                            </TableCell>
                            <TableCell sx={{color:'background.text'}}>
                              <IconButton
                                aria-label="expand row"
                                size="small"
                                onClick={() => setOpenRow(openRow === idx ? null : idx)}
                              >
                                {openRow === idx ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                              </IconButton>
                            </TableCell>
                          </TableRow>

                          {/* inner table spans full row */}
                          <TableRow>
                            <TableCell sx={{ p: 0 }} colSpan={7}>
                              <Collapse in={openRow === idx} timeout="auto" unmountOnExit>
                                <Box sx={{ p: 2 }}>
                                  <Table size="small" sx={{ width:'100%', tableLayout:'fixed', background:'#e6f2ff', borderRadius:1 }}>
                                    <TableHead>
                                      <TableRow>
                                        <TableCell><b>Sl No</b></TableCell>
                                        <TableCell><b>Payment Type</b></TableCell>
                                        <TableCell><b>Date</b></TableCell>
                                        <TableCell><b>Status</b></TableCell>
                                        <TableCell><b>Service Type</b></TableCell>
                                        <TableCell><b>Amount</b></TableCell>
                                        <TableCell><b>PRO</b></TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {patientPayments.map((payment, pidx) => (
                                        <TableRow key={payment._id || pidx}>
                                          {/* alphabetic SL for inner rows */}
                                          <TableCell>{toAlphabetLabel(pidx)}</TableCell>
                                          <TableCell>
                                            <Typography color={payment?.TASP_Payment_Type === 1 ? 'green' : 'red'}>
                                              {payment.TASP_Payment_Type === 1 ? 'Online' : 'Offline'}
                                            </Typography>
                                          </TableCell>
                                          <TableCell>
                                            {payment.TASP_Created_At ? new Date(payment.TASP_Created_At).toLocaleString() : '-'}
                                          </TableCell>
                                          <TableCell>
                                            <PillComponent status={payment.TASP_IsPaid ? 'paid' : 'unpaid'} />
                                          </TableCell>
                                          <TableCell>
                                            {payment.TASP_Request_Service_Ref.TA_Service_Name}
                                          </TableCell>
                                          <TableCell>
                                            <CurrencyRupeeIcon fontSize="inherit" style={{verticalAlign:'middle'}} />
                                            {(Number(payment.TASP_Amount)||0).toLocaleString('en-IN')}/-
                                          </TableCell>
                                          <TableCell>{payment.proName || '-'}</TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </Box>
                              </Collapse>
                            </TableCell>
                          </TableRow>
                        </React.Fragment>
                      );
                    })}
                  </TableBody>
                </>
              ) : (
                // ========== ALL PAYMENTS TABLE (new) ==========
                <>
                  <TableHead>
                    <TableRow>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >SL No.</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Name</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Phone Number</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Email</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Payment Type</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Status</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Service Type</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Date</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >Amount</TableCell>
                      <TableCell sx={{ fontWeight: 700, fontSize: '1rem', background: theme.palette.primary.main, color: theme.palette.mode === 'dark' ? '#fff' : theme.palette.primary.contrastText }} >PRO</TableCell>
                    </TableRow>
                  </TableHead>

                  <TableBody>
                    {paginatedAll.map((p, idx) => (
                      <TableRow key={p._id || idx}>
                        <TableCell sx={{color:'background.text'}}>{page * rowsPerPage + idx + 1}</TableCell>
                        <TableCell sx={{color:'background.text'}}>{p.userName || '-'}</TableCell>
                        <TableCell sx={{color:'background.text'}}>{p.mobileNumber || '-'}</TableCell>
                        <TableCell sx={{color:'background.text'}}>{p.userEmail || '-'}</TableCell>
                        <TableCell>
                          <Typography color={p?.TASP_Payment_Type === 1 ? 'green' : 'red'}>
                            {p.TASP_Payment_Type === 1 ? 'Online' : 'Offline'}
                          </Typography>
                        </TableCell>
                        <TableCell>
                          <PillComponent status={p.TASP_IsPaid ? 'paid' : 'unpaid'} />
                        </TableCell>
                        <TableCell>
                          {p.TASP_Request_Service_Ref.TA_Service_Name}
                        </TableCell>
                        <TableCell sx={{color:'background.text'}}>{p.TASP_Created_At ? new Date(p.TASP_Created_At).toLocaleString() : '-'}</TableCell>
                        <TableCell sx={{color:'background.text'}}>
                          <CurrencyRupeeIcon fontSize="inherit" style={{verticalAlign:'middle'}} />
                          {(Number(p.TASP_Amount)||0).toLocaleString('en-IN')}/-
                        </TableCell>
                        <TableCell sx={{color:'background.text'}}>{p.proName || '-'}</TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </>
              )}
            </Table>
            </TableContainer>

            
          )}
          

          {
            isGroup ? (
              <Box sx={{ px: 2, py: 1 }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              rowsPerPage={rowsPerPage}
              // count={patientList.length}
              count={filteredPayments.length}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}–${to} of ${count}`
              }
              sx={{ color: "background.text" }}
            />
          </Box>
            ):(
              <Box sx={{ px: 2, py: 1 }}>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25]}
              component="div"
              rowsPerPage={rowsPerPage}
              count={patientList.length}
              // count={filteredPayments.length}
              page={page}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              labelRowsPerPage="Rows per page:"
              labelDisplayedRows={({ from, to, count }) =>
                `${from}–${to} of ${count}`
              }
              sx={{ color: "background.text" }}
            />
          </Box>
            )
          }

          {filteredPayments.length > 0 && (
            <Box >
              {
                statusFilter === 'unpaid' ? '':(
                <Box
                  sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',backgroundColor: '#e8f6ffff',padding: 1,borderRadius: 1,color: 'black',fontWeight: 700,}}>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'end',alignItems:'center',display:'flex'}}>Grand Total Collected Amount:</Box>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'start',alignItems:'center',display:'flex',color:'green'}}>
                    <CurrencyRupeeIcon sx={{ fontSize: 14, }} />
                    {calculateTotalCollectedAmount()}/-
                  </Box>
                </Box>  
                )
              }

              {
                statusFilter === 'paid' ? '':(
                <Box
                  sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',backgroundColor: '#e8f6ffff',padding: 0.5,borderRadius: 1,color: 'black',fontWeight: 700,}}>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'end',alignItems:'center',display:'flex'}}>Grand Total Non Collected Amount:</Box>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'start',alignItems:'center',display:'flex',color:'red'}}>
                    <CurrencyRupeeIcon sx={{ fontSize: 14, }} />
                    {calculateTotalNonCollectedAmount()}/-
                  </Box>
                </Box> 
                )
              }

              {
                statusFilter === 'paid' || statusFilter === 'unpaid' ? '':(
                <Box
                  sx={{display: 'flex',justifyContent: 'center',alignItems: 'center',backgroundColor: '#e8f6ffff',padding: 0.5,borderRadius: 1,color: 'black',fontWeight: 700,}}>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'end',alignItems:'center',display:'flex'}}>Grand Total Amount:</Box>
                  <Box sx={{backgroundColor:'',width:'50%',justifyContent:'start',alignItems:'center',display:'flex'}}>
                    <CurrencyRupeeIcon sx={{ fontSize: 14, }} />
                    {calculateTotalAmount()}/-
                  </Box>
                </Box>
                )
              }
            </Box>
          )}
          
        </Paper>
      )}
    </Box>
  );
}

export default PatientPaymentReportPage;
